import { Skeleton, Row, FlowGrid } from '@fs/zion-ui'
import { css } from '@emotion/core'
import React from 'react'

const scrollCss = css`
  overflow: auto;
`

export default function ActivityGroupGridLoadingSkeleton() {
  return (
    <>
      <hr style={{ width: '100%', opacity: '0.2' }} />
      <Skeleton.H5 />
      <Row css={scrollCss}>
        <FlowGrid noShrinkX columnCount={3}>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
        </FlowGrid>
      </Row>
      <hr style={{ width: '100%', opacity: '0.2' }} />
      <Skeleton.H5 />

      <Row css={scrollCss}>
        <FlowGrid noShrinkX columnCount={4}>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
        </FlowGrid>
      </Row>

      <hr style={{ width: '100%', opacity: '0.2' }} />
      <Skeleton.H5 />

      <Row css={scrollCss}>
        <FlowGrid noShrinkX columnCount={2}>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
        </FlowGrid>
      </Row>

      <hr style={{ width: '100%', opacity: '0.2' }} />
      <Skeleton.H5 />

      <Row css={scrollCss}>
        <FlowGrid noShrinkX columnCount={3}>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
          <FlowGrid columnCount={1}>
            <Skeleton.Image columns={1} width={160} height={160} />
            <Skeleton.Paragraph lineCount={1} size="md" />
          </FlowGrid>
        </FlowGrid>
      </Row>
    </>
  )
}
